module.exports = "\n<router-outlet></router-outlet>\n\n<toaster-container></toaster-container>"


//////////////////
// WEBPACK FOOTER
// D:/FMFB/FMFB Dashboard/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main